import React from 'react';
import {
  PAYROLL_EFFECT_OPTIONS, BALANCE_EFFECT_OPTIONS,
  MONTHLY_GRANT_EFFECT_OPTIONS, CALENDAR_EFFECT_OPTIONS,
  WEEKLY_HOLIDAY_EFFECT_OPTIONS,
} from './constants';
import { inputStyle, formLabelStyle } from './stylesB';
import { payrollEffectPatch, eventTypeWeeklyPatch, showsWeeklyHolidayField } from './payrollEffectRules';

export function EffectFields({ form, updateFormWithRules, eventTypes = [] }) {
  const applyEventType = (value) => {
    const selected = eventTypes.find((item) => String(item.id) === String(value));
    if (!selected) {
      updateFormWithRules({ event_type_id: '', event_name: '' }, { notify: false });
      return;
    }
    updateFormWithRules({
      event_type_id: String(selected.id),
      event_name: selected.name,
      type: selected.type || form.type,
      category: selected.category || form.category,
      count: selected.default_count != null ? String(Number(selected.default_count)) : form.count,
      payroll_effect: selected.payroll_effect,
      leave_balance_effect: selected.leave_balance_effect,
      monthly_grant_effect: selected.monthly_grant_effect,
      calendar_effect: selected.calendar_effect,
      grant_decision_source: 'manual',
      ...eventTypeWeeklyPatch(form, selected), // 템플릿엔 주휴 칸이 없다 — '급여 영향 없음' 템플릿이면 주휴도 영향 없음
    }, { notify: false });
  };

  return (
    <>
      {eventTypes.length > 0 && (
        <div style={{ display: 'grid', gap: 4, gridColumn: '1 / -1' }}>
          <label style={formLabelStyle}>유형 템플릿</label>
          <select
            style={inputStyle}
            value={form.event_type_id || ''}
            onChange={(e) => applyEventType(e.target.value)}
          >
            <option value="">직접 설정</option>
            {eventTypes.map((item) => (
              <option key={item.id} value={item.id}>{item.name}</option>
            ))}
          </select>
        </div>
      )}
      <div style={{ display: 'grid', gap: 4 }}>
        <label style={formLabelStyle}>급여 계산</label>
        <select
          style={inputStyle}
          value={form.payroll_effect || 'paid_cover'}
          // '급여 영향 없음' 을 고르면 잔여연차·월차·주휴도 '영향 없음' 으로, 거기서 돌리면 기본값으로(payrollEffectRules.js, 2026-10-01)
          onChange={(e) => updateFormWithRules(payrollEffectPatch(form, e.target.value), { notify: false })}
        >
          {PAYROLL_EFFECT_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
      {/* 주휴수당 영향: 무급 공제·급여 영향 없음일 때(2026-10-01 — 예전엔 무급만). 회사 지정 무급휴가(여름휴가 등)는
          '영향 없음'으로 그 주 주휴 유지. 유급 인정은 계산이 늘 주휴를 유지해 숨긴다. */}
      {showsWeeklyHolidayField(form) && (
        <div style={{ display: 'grid', gap: 4 }}>
          <label style={formLabelStyle}>주휴수당 영향</label>
          <select
            style={inputStyle}
            value={form.affects_weekly_holiday !== false ? 'affects' : 'none'}
            onChange={(e) => updateFormWithRules({ affects_weekly_holiday: e.target.value === 'affects' }, { notify: false })}
          >
            {WEEKLY_HOLIDAY_EFFECT_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
          </select>
        </div>
      )}
      <div style={{ display: 'grid', gap: 4 }}>
        <label style={formLabelStyle}>잔여연차 계산</label>
        <select
          style={inputStyle}
          value={form.leave_balance_effect || 'deduct'}
          onChange={(e) => updateFormWithRules({ leave_balance_effect: e.target.value, event_type_id: '', event_name: '' }, { notify: false })}
        >
          {BALANCE_EFFECT_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
      <div style={{ display: 'grid', gap: 4 }}>
        <label style={formLabelStyle}>월차 발생</label>
        <select
          style={inputStyle}
          value={form.monthly_grant_effect || 'neutral'}
          onChange={(e) => updateFormWithRules({ monthly_grant_effect: e.target.value, event_type_id: '', event_name: '' }, { notify: false })}
        >
          {MONTHLY_GRANT_EFFECT_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
      <div style={{ display: 'grid', gap: 4 }}>
        <label style={formLabelStyle}>달력 표시</label>
        <select
          style={inputStyle}
          value={form.calendar_effect || 'full_day'}
          onChange={(e) => updateFormWithRules({ calendar_effect: e.target.value, event_type_id: '', event_name: '' }, { notify: false })}
        >
          {CALENDAR_EFFECT_OPTIONS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
    </>
  );
}
